/**
 * Geo-targeting functionality for Soundbox Store
 * Handles location detection and form requirements based on user's location
 */
(function() {
  'use strict';

  const GeoTargeting = {
    // Configuration for different cities/regions
    config: {
      apiUrl: 'https://test.hieunguyenel2686.workers.dev/',
      cities: {
        london: {
          name: 'London',
          requiredFields: ['request-showroom-visit', 'free-site-survey']
        },
        default: {
          requiredFields: ['request_remote_tour']
        }
      }
    },

    /**
     * Initialize geo-targeting functionality
     */
    init: function() {
      this.detectLocation();
    },

    /**
     * Fetch user's location from the API
     */
    detectLocation: function() {
      fetch(this.config.apiUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          this.handleLocationData(data);
        })
        .catch(error => {
          console.warn('Geo-targeting: Failed to detect location', error);
          this.handleLocationData({ city: 'Unknown' });
        });
    },

    /**
     * Handle the location data received from API
     * @param {Object} locationData - Object containing city information
     */
    handleLocationData: function(locationData) {
      const city = locationData.city || 'Unknown';
      
      // Set city attribute on HTML element
      document.querySelector('html').setAttribute('city', city);
      
      // Update form requirements based on location
      this.updateFormRequirements(city);
      
      // Trigger custom event for other scripts that might need this data
      document.dispatchEvent(new CustomEvent('geo-targeting:location-detected', {
        detail: { city: city, data: locationData }
      }));
    },

    /**
     * Update form field requirements based on user's location
     * @param {string} city - User's detected city
     */
    updateFormRequirements: function(city) {
      // Check if GRFQConfigs exists (form configuration)
      if (typeof GRFQConfigs === 'undefined' || !GRFQConfigs.form_elements) {
        return;
      }

      const cityConfig = city.toLowerCase() === 'london' 
        ? this.config.cities.london 
        : this.config.cities.default;

      // Update required fields based on location
      cityConfig.requiredFields.forEach(fieldCode => {
        const field = GRFQConfigs.form_elements.find(element => element.code === fieldCode);
        if (field) {
          field.required = 1;
        }
      });

      console.log(`Geo-targeting: Updated form requirements for ${city}`);
    },

    /**
     * Get current detected city
     * @returns {string} Current city or 'Unknown'
     */
    getCurrentCity: function() {
      const htmlElement = document.querySelector('html');
      return htmlElement.getAttribute('city') || 'Unknown';
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      GeoTargeting.init();
    });
  } else {
    GeoTargeting.init();
  }

  // Expose to global scope for potential external use
  window.GeoTargeting = GeoTargeting;

})();